import { z } from 'src/lib'
import { OperacionWRMFields, getEndpoint } from '.'
import { BaseResponse } from 'src/types'
import { HttpAxiosRequest } from 'src/http/httpAxiosBase'

const schema = z.object({
    [OperacionWRMFields.CodSectorComercial]: z.number(),
    [OperacionWRMFields.Observaciones]: z.string().optional(),
    [OperacionWRMFields.FechaEmision]: z.date().optional().nullable(),
    [OperacionWRMFields.FechaVencimiento]: z.date()
})

export type OperacionWRM_Update = z.infer<typeof schema>

export const put = (idOperacion: number, operacion: OperacionWRM_Update): Promise<BaseResponse> => {
    const endpoint = getEndpoint(`${idOperacion}`)

    const parsed = schema.safeParse(operacion)

    if (!parsed.success) {
        console.error('Error de validación:', parsed.error.issues)

        return Promise.reject(new Error('Error de validación.'))
    }

    return HttpAxiosRequest.put(endpoint, operacion)

    // .then(response => {
    //     return Promise.resolve(response)
    // })
    // .catch(error => {
    //     console.error('Error de red:', error)

    //     return Promise.reject('Error de red.')
    // })
}
